import type { MuiTheme as Theme } from '@paintscout/ui'
import { makeStyles } from '@paintscout/ui'

export const useWorkOrderViewDialogStyles = makeStyles<Theme>(
  (theme) => ({
    root: { display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' },
    dialogTitle: {},
    dialogContent: { maxWidth: '100%', overflowX: 'hidden' },
    closeIcons: { display: 'flex', justifyContent: 'flex-end', gap: theme.spacing(1) },
    cancel: {},
    confirm: {}
  }),
  { name: 'WorkOrderViewDialogDialog' }
)
